export default __webpack_public_path__ + "static/media/landmark.5cd293ce.jpg";